import classNames from 'classnames';
import type { LocaleResources } from 'locales';
import { YAMAZAKI_GIFT_202504_IMAGE_BASE_PATH } from 'pages/campaign/yamazaki-gift-202504';
import type { FC } from 'react';
import { NextImage } from 'src/components/shared/elements/NextImage';
import type { LOCALE_TYPE } from 'src/types/locale';

type Props = {
  locale: LOCALE_TYPE;
  localeResources: LocaleResources;
};

export const PrizeContent: FC<Props> = ({ locale, localeResources }) => {
  return (
    <div className="flex flex-col gap-10 justify-center items-center w-full">
      <div className="max-w-[1130px] w-full h-[565px] hidden semiLg:block">
        <NextImage
          src={`${YAMAZAKI_GIFT_202504_IMAGE_BASE_PATH}/prize/banner/desktop/${locale}.webp`}
          alt="yamazaki prize content"
          width={1130}
          height={565}
          layout="responsive"
        />
      </div>
      <div className="w-[360px] h-[561px] semiLg:hidden">
        <NextImage
          src={`${YAMAZAKI_GIFT_202504_IMAGE_BASE_PATH}/prize/banner/mobile/${locale}.webp`}
          alt="yamazaki prize content"
          width={360}
          height={561}
        />
      </div>
      <div className={classNames('max-w-[896px] px-6 text-sm leading-7 font-medium text-white')}>
        <ul className="list-disc">
          <li>{localeResources.yamazakiGift.prize.list1}</li>
          <li>{localeResources.yamazakiGift.prize.list2}</li>
          <li>{localeResources.yamazakiGift.prize.list3}</li>
        </ul>
      </div>
    </div>
  );
};
